module.exports = __webpack_public_path__ + "img/snow.5b173138.jpeg";